import React, { Fragment } from 'react'
import PagesHeader from '../common/components/PagesHeader'
import FAQ from '../common/components/FAQ'
import PartnersCTA from '../common/components/PartnersCTA'
import AwardBadges from '../common/components/AwardBadges'
import HomeHeader from './Header/HomeHeader'
import WhyYard from './WhyYard'
import OurLoansForYou from './OurLoansForYou'
import HowItWorks from './HowItWorks'
import CurrentOffers from './CurrentOffers'
import EstimateSavings from './EstimateSavings/EstimateSavings'
import Team from './Team'
import TrustPilot from '../common/components/TrustPilot'
import HubspotContactForm from '../common/components/HubspotContactForm'


function App() {
  return(
    <Fragment>
      <HomeHeader />
      <WhyYard />
      <OurLoansForYou />
      <AwardBadges header={<h3 className='text-center mt-4 mb-5 mr-1 ml-1'>We're an award winning lender!</h3>} />
      <HowItWorks />
      <CurrentOffers />
      <EstimateSavings />
      <Team />
      <TrustPilot templateId='53aa8912dec7e10d38f59f36' height="140px"/>
      <PartnersCTA />
      <HubspotContactForm />
    </Fragment>
  )
}

export default App
